const Divider = {
  baseStyle: {
    borderColor: 'gray.150',
    opacity: 1,
    my: 4,
  },
}

export default Divider
